import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "y-center" }, null, -1)
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "list-card" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "p-card-aside"
}
const _hoisted_6 = { class: "text-red" }
const _hoisted_7 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Card, null, {
      header: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("img", {
          class: "m-h-100",
          src: _ctx.src,
          alt: _ctx.name
        }, null, 8, _hoisted_2)
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["scroll-x text-left", [(_ctx.aside) ? 'h-70' : 'h-100']])
        }, [
          _createElementVNode("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content, (d) => {
              return (_openBlock(), _createElementBlock("li", {
                key: d.id
              }, [
                _createElementVNode("span", { innerHTML: d }, null, 8, _hoisted_4)
              ]))
            }), 128))
          ])
        ], 2),
        (_ctx.aside)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("small", _hoisted_6, _toDisplayString(_ctx.aside), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.urls, (u) => {
          return (_openBlock(), _createElementBlock("div", {
            key: u.id
          }, [
            _createElementVNode("a", {
              href: u.url,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleOnClick(_ctx.id))),
              target: "_blank"
            }, [
              _createVNode(_component_Button, {
                icon: "fas fa-arrow-right",
                iconPos: "right",
                label: u.name || 'Solicitar',
                class: "bg-yellow-500 border-yellow-500 p-button-rounded text-900 strong"
              }, null, 8, ["label"])
            ], 8, _hoisted_7)
          ]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}